// Chakra 
import { 
  Button,
  Flex, 
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text, 
} from '@chakra-ui/react';
import { FaCheckCircle } from 'react-icons/fa';

// Assets
import { interestsOptions } from 'services/Utils';
import { textLang } from 'services/Lang';

const FiltersModal = ({
  interests, 
  toggleInterest, 
  onOpen, isOpen, onClose,
  globalSearch,
  setGlobalSearch,
}) => {
  return (
    	<> 
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent className="modal__simple" 
              maxW={{ base: '330px' }} 
              style={{ border:'1px solid #2ABDFD', overflow: 'hidden' }}>
                            
              <Box position="relative" p="40px 20px 24px 20px" bg='white !important' textAlign="center">
                  <Text variant="title-lg" fontSize="24px" textAlign="left">
                    {textLang('filters')}
                  </Text>

                  <Text variant="text-md" mt="8px" textAlign="left">
                    {textLang('filters_desc')}
                  </Text>

                  <Text variant="title-lg" mt="16px" textAlign="left">
                    {textLang('interests')}
                  </Text>

                  <Box position="relative">
                    <Box
                      pointerEvents="none"
                      w="100%" h="30px" position="absolute" top="0" left="0" bg="linear-gradient(180deg, white, transparent)" zIndex="9" />
                    <Box overflow="scroll" pb="30px" height="38vh" border="1px solid white">
                      <Flex flexWrap="wrap" gap="8px" mt="12px" justifyContent="center">
                        {interestsOptions().map((interest) => (
                          <Box
                            key={interest}
                            cursor="pointer"
                            px="12px"
                            py="6px"
                            borderRadius="16px"
                            border="1px solid"
                            bg={interests?.includes(interest) ? '#0088cc' : 'transparent'}
                            color={interests?.includes(interest) ? 'white' : 'black'}
                            fontWeight="500"
                            onClick={() => toggleInterest(interest)}
                            transition="0.2s ease-in-out"
                          >
                            {textLang(interest)}
                          </Box>
                        ))}
                      </Flex>
                    </Box>
                    <Box
                      pointerEvents="none" 
                      w="100%" h="30px" position="absolute" bottom="0" left="0" bg="linear-gradient(0deg, white, transparent)" zIndex="9" />
                  </Box>

                  
              </Box>

          </ModalContent>
        </Modal> 
      </>
  );
};

export default FiltersModal;